import { observer } from 'mobx-react';
import { useStore } from '../../../state/MobxContext';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
// import LockImage from '../Main/image/lock.png';
import LockImage from '../../Main/image/lock.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import { toJS } from 'mobx';











function CloverLockPage() {
  const { loginStore } = useStore();
  const { CoinStore } = useStore();

  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '450px',
      maxWidth: '450px',
      height: "560px",
      maxHeight: "560px",
      // backgroundColor: 'rgba( 255, 255, 255, 0.8 )',
      boxShadow: 'none',
    },
    DialogMobile: {
      height: '80%',
      width: '80%',
      minWidth: "320px",
      padding: '0',
      // backgroundColor: 'rgba( 255, 255, 255, 0.8 )',
      boxShadow: 'none',
    },

  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  let UserLockinfo = toJS(CoinStore?.UserCoinLockTokenDatainfo);


  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF",
      fontSize: "1.5rem"


    }
  })(Typography);

  const isCloverLockPageDialogOpen = loginStore?.isCloverLockPageDialogOpen;


  return (
    <div>
      <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCloverLockPageDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
            <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
              <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
              <WhiteTextTypography >My.Lock</WhiteTextTypography>
            </Grid>
            <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
              <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CloverLockPageFalse") }} />
            </Grid>
          </Grid>
        </Box>
        <DialogContent >
          <Box sx={isMobile ? { border: 1, borderRadius: '10px', margin: '-5px', marginTop: '0px', p: 1, overflow: 'auto', overflowY: "scroll",
              height: "95%",
        }
            :
            {
              border: 1, borderRadius: '10px', marginTop: '10px', p: 1,
              width: "250px",
              height: "410px",
              overflow: 'auto',
              overflowY: "scroll",
            }}>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' justifyContent='center' alignItems='center' gap={0.5}>
              {UserLockinfo.length > 0 &&
                UserLockinfo.map((BData, index) => (
                  <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='flex-start' alignItems='center' key={index}>
                    <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} gap={0.5} direction='row'
                    >
                      <img style={{ width: '25px', height: "25px" }} src={LockImage} alt='LockImage' />
                      <Typography>
                        {BData.balance}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}
                    >
                      <Typography>
                        Time:{BData.releaseTime}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default observer(CloverLockPage);